var WarmupQuestions = require("lib/academic/WarmupQuestions");

class NonFictionPicturesQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionPicturesQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [FEATURE_TYPE_STAGE];
		}

		var numPics = answers[NUM_PICS];
		var features = answers[FEATURES].split(",");
		if ((this.props.level == "1" && !numPics) || (this.props.level != "1" && !features)) {
			return [FEATURE_TYPE_STAGE];
		}

		if ((numPics && numPics == "0") || (features && features.includes("none"))) {
			return [FEATURE_TYPE_STAGE, true];
		}

		if (!answers[FEATURE_1_DESC]) {
			return [DESCRIBE_1_STAGE];
		}
		if (this.props.level == "3" && !answers[FEATURE_1_TYPE]) {
			return [INFO_TYPE_1_STAGE];
		}

		if ((numPics && numPics == "1") || (features && features.length < 2)) {
			if (this.props.level == "3") {
				return [INFO_TYPE_1_STAGE, true];
			} else {
				return [DESCRIBE_1_STAGE, true];
			}
		}

		if (!answers[FEATURE_2_DESC]) {
			return [DESCRIBE_2_STAGE];
		}
		if (this.props.level == "3" && !answers[FEATURE_2_TYPE]) {
			return [INFO_TYPE_2_STAGE];
		}

		if (this.props.level == "1") {
			return [DESCRIBE_2_STAGE, true];
		}

		if (features.length < 3) {
			if (this.props.level == "3") {
				return [INFO_TYPE_2_STAGE, true];
			} else {
				return [DESCRIBE_2_STAGE, true];
			}
		}

		if (!answers[FEATURE_3_DESC]) {
			return [DESCRIBE_3_STAGE];
		}
		if (this.props.level == "3" && !answers[FEATURE_3_TYPE]) {
			return [INFO_TYPE_3_STAGE];
		}

		if (this.props.level == "3") {
			return [INFO_TYPE_3_STAGE, true];
		} else {
			return [DESCRIBE_3_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		if (this.props.level == "1") {
			var featureTypeInput = this.props.renderDropdownF("choices1", FEATURE_TYPE_STAGE, NUM_PICS, [NUM_PICS]);
		} else {
			var featureTypeInput = this.props.renderMultiSelectF("choices1", FEATURE_TYPE_STAGE, FEATURES, 3, [FEATURES]);
		}
		var featureTypeDisplay = (
			<div>
				{ this.props.getTextF("label1", FEATURE_TYPE_STAGE) }
				{ featureTypeInput }
			</div>
		);

		var answers = this.props.answers[NonFictionPicturesQuestion.STEM];
		if (answers && answers[FEATURES]) {
			var features = answers[FEATURES].split(",");
		}

		if (_.indexOf(STAGES, stage) > 0) {
			if (features) {
				var replacementsHash1 = {};
				replacementsHash1[WarmupQuestions.FEATURE_TYPE] = features[0];
			}
			var describe1Display = (
				<div>
					{ this.props.getTextF("label1", DESCRIBE_1_STAGE, replacementsHash1) }
					{ this.props.renderInputF(FEATURE_1_DESC) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) > 1 && this.props.level == "3") {
			var infoType1Display = (
				<div>
					{ this.props.getTextF("label1", INFO_TYPE_1_STAGE) }
					{ this.props.renderDropdownF("choices1", INFO_TYPE_1_STAGE, FEATURE_1_TYPE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			if (features) {
				var replacementsHash2 = {};
				replacementsHash2[WarmupQuestions.FEATURE_TYPE] = features[1];
			}
			var describe2Display = (
				<div>
					{ this.props.getTextF("label1", DESCRIBE_2_STAGE, replacementsHash2) }
					{ this.props.renderInputF(FEATURE_2_DESC) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) > 3 && this.props.level == "3") {
			var infoType2Display = (
				<div>
					{ this.props.getTextF("label1", INFO_TYPE_2_STAGE) }
					{ this.props.renderDropdownF("choices1", INFO_TYPE_2_STAGE, FEATURE_2_TYPE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 4) {
			if (features) {
				var replacementsHash3 = {};
				replacementsHash3[WarmupQuestions.FEATURE_TYPE] = features[2];
			}
			var describe3Display = (
				<div>
					{ this.props.getTextF("label1", DESCRIBE_3_STAGE, replacementsHash3) }
					{ this.props.renderInputF(FEATURE_3_DESC) }
				</div>
			);
		}
		if (_.indexOf(STAGES, stage) > 5 && this.props.level == "3") {
			var infoType3Display = (
				<div>
					{ this.props.getTextF("label1", INFO_TYPE_3_STAGE) }
					{ this.props.renderDropdownF("choices1", INFO_TYPE_3_STAGE, FEATURE_3_TYPE) }
				</div>
			);
		}


		return (
			<div>
				{ featureTypeDisplay }
				{ describe1Display }
				{ infoType1Display }
				{ describe2Display }
				{ infoType2Display }
				{ describe3Display }
				{ infoType3Display }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionPicturesQuestion.STEM = "nfpic";

// stages
var FEATURE_TYPE_STAGE = "featuretype";
var DESCRIBE_1_STAGE = "describe1";
var INFO_TYPE_1_STAGE = "infotype1";
var DESCRIBE_2_STAGE = "describe2";
var INFO_TYPE_2_STAGE = "infotype2";
var DESCRIBE_3_STAGE = "describe3";
var INFO_TYPE_3_STAGE = "infotype3";

var STAGES = [
	FEATURE_TYPE_STAGE, DESCRIBE_1_STAGE, INFO_TYPE_1_STAGE, DESCRIBE_2_STAGE, INFO_TYPE_2_STAGE,
	DESCRIBE_3_STAGE, INFO_TYPE_3_STAGE
];

// answer keys
var NUM_PICS = "num_pictures";
var FEATURES = "features";
var FEATURE_1_DESC = "feature_1_description";
var FEATURE_1_TYPE = "feature_1_type";
var FEATURE_2_DESC = "feature_2_description";
var FEATURE_2_TYPE = "feature_2_type";
var FEATURE_3_DESC = "feature_3_description";
var FEATURE_3_TYPE = "feature_3_type";

NonFictionPicturesQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionPicturesQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionPicturesQuestion.js